import React from 'react';
import uuid from 'uuid/v4';
import styled from 'styled-components';

import { ModalProps } from '../types';
import Modal from '../../Modal/index';

import WalletIcon from '../../../../icons/ic_wallet.svg';

import i18n from 'i18n';
import { AppType } from '../../../../constants';

const IsPaidNotice = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;

  margin: 15px;
`;

const PaidAppWarningText = styled.div`
  font-size: 16px;
  line-height: 24px;

  text-align: center;
  letter-spacing: -0.32px;

  color: #112530
`;

const ProceedWithCautionText = styled.div`
  color: #000000;
  font-weight: bold;

  font-size: 16px;
  line-height: 24px;

  text-align: center;
  letter-spacing: -0.32px;
`;

const ChangeMindText = styled.div`
  margin-top: 20px;

  font-size: 16px;
  line-height: 24px;

  text-align: center;
  letter-spacing: -0.32px;
`;

const FitbitClockGalleryText = styled.b`
  text-transform: capitalize;
`;

const WalletIconContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;

  margin-top: 25px;
`;

const WalletIconImage = styled.img``;

interface AppIsPaidModalProps extends ModalProps {}

class AppIsPaidModal extends React.Component<AppIsPaidModalProps> {
  render() {
    const {
      app,
      onSuccess,
      onCancel,
    } = this.props;

    const appType = app.type;
    let texts;

    if(appType === AppType.CLOCK.toUpperCase()) {
      texts = {
        itemIsPaidText: 'component.AppIsPaidModal.textClock',
        changeMindText: 'component.AppIsPaidModal.changeMindClock',
        galleryText: 'component.AppIsPaidModal.fitbitClockGallery'
      }
    } else {
      texts = {
        itemIsPaidText: 'component.AppIsPaidModal.textApp',
        changeMindText: 'component.AppIsPaidModal.changeMindApp',
        galleryText: 'component.AppIsPaidModal.fitbitAppGallery'
      }
    }
    return (
      <Modal
        id={`AppIsPaidModal-${uuid()}`}
        contentAbove={
          <WalletIconContainer>
            <WalletIconImage src={WalletIcon} />
          </WalletIconContainer>
        }
        contentCenter={
          <IsPaidNotice>
            <PaidAppWarningText>
              {i18n(texts.itemIsPaidText)()}
              <b>{i18n('component.AppIsPaidModal.notEndorsed')()}</b>
            </PaidAppWarningText>
            <ProceedWithCautionText>{i18n('component.AppIsPaidModal.caution')()}</ProceedWithCautionText>
            <ChangeMindText>
              {i18n(texts.changeMindText)()}
              <FitbitClockGalleryText>{i18n(texts.galleryText)()}</FitbitClockGalleryText>
            </ChangeMindText>
          </IsPaidNotice>
        }
        title={i18n('component.AppIsPaidModal.title')({ appName: app.name })}
        onClose={onCancel}
        buttons={[
          {
            text: i18n('component.PermissionModal.disallowButtonText')(),
            onClick: onCancel,
            id: 'app-is-paid-button-cancel',
          },
          {
            text: i18n('component.PermissionModal.allowButtonText')(),
            onClick: onSuccess,
            highlight: true,
            id: 'app-is-paid-button-ok',
          }
        ]}
      />
    );
  }
}

export default AppIsPaidModal;
